export type T_Lang = 'cn' | 'en'

/**
 * $t('enum.E_Lang.cn')
 * $t('enum.E_Lang.en')
 */
export enum E_Lang {
    cn = 'cn',
    en = 'en',
}